"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Cross_1 = __importDefault(require("@kawaui/icons/build/icons/navigation/Cross"));
const react_1 = require("react");
const styled_components_1 = require("styled-components");
const constants_1 = require("../../constants");
const loginBtn_1 = __importDefault(require("../loginBtn"));
const menuButton_1 = __importDefault(require("../menuButton"));
const section_1 = __importDefault(require("./section"));
const Styled = __importStar(require("./styles"));
const LateralMenu = ({ isOpenDoor, loginElement, lateralSignUpElement, loginText, lateralLoggedInHeader, lateralLoggedInFooter, menu, }) => {
    var _a;
    const theme = (0, styled_components_1.useTheme)();
    const [isMobile, setIsMobile] = (0, react_1.useState)(false);
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const [bodyStyle, setBodyStyle] = (0, react_1.useState)({ overflow: '', paddingRight: '' });
    const [bodyScroll, setBodyScroll] = (0, react_1.useState)(0);
    const menuContainerRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (typeof window === 'undefined')
            return;
        const handler = () => {
            setIsMobile(window.innerWidth < parseInt(theme.breakpoint.desktop, 10));
        };
        setIsMobile(window.innerWidth < parseInt(theme.breakpoint.desktop, 10));
        window.addEventListener('resize', handler);
        return () => window.removeEventListener('resize', handler);
    }, [setIsMobile]);
    (0, react_1.useEffect)(() => {
        if (isMobile && isOpen && document) {
            enableBodyLock();
        }
        else if (isMobile && !isOpen && document) {
            disableBodyLock();
        }
    }, [isMobile, isOpen]);
    const enableBodyLock = () => {
        setBodyStyle({ overflow: document.body.style.overflow, paddingRight: document.body.style.paddingRight });
        setBodyScroll(window.pageYOffset);
        document.body.style.overflow = 'hidden';
        document.body.style.paddingRight = '0px';
        document.body.style.position = 'fixed';
        document.body.style.top = `-${window.pageYOffset}px`;
        document.body.style.width = '100%';
    };
    const disableBodyLock = () => {
        document.body.style.overflow = (bodyStyle && bodyStyle.overflow) || 'auto';
        document.body.style.paddingRight = (bodyStyle && bodyStyle.paddingRight) || '0px';
        document.body.style.removeProperty('position');
        document.body.style.removeProperty('top');
        document.body.style.removeProperty('width');
        setBodyStyle({ overflow: '', paddingRight: '' });
        window.scrollTo(0, bodyScroll);
    };
    (0, react_1.useEffect)(() => {
        const handleFocusOut = (event) => {
            const newFocusedEl = event.relatedTarget;
            if (menuContainerRef.current && !menuContainerRef.current.contains(newFocusedEl) && newFocusedEl !== null)
                setIsOpen(false);
        };
        if (menuContainerRef.current)
            menuContainerRef.current.addEventListener('focusout', handleFocusOut);
        return () => {
            if (menuContainerRef.current)
                menuContainerRef.current.removeEventListener('focusout', handleFocusOut);
        };
    }, []);
    (0, react_1.useEffect)(() => {
        const handleCloseMenu = () => setIsOpen(false);
        document.addEventListener('closeLeftMenu', handleCloseMenu);
        return () => {
            document.removeEventListener('closeLeftMenu', handleCloseMenu);
        };
    }, []);
    const handleTogglerCtaClick = () => {
        setIsOpen(!isOpen);
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Styled.MenuOverlay, { "$isOpen": isOpen, onClick: () => setIsOpen(false) }), (0, jsx_runtime_1.jsxs)(Styled.MenuContainer, { ref: menuContainerRef, "data-facil-iti": "header-menu", "data-testid": "header-menu", children: [(0, jsx_runtime_1.jsx)(menuButton_1.default, { isOpen: isOpen, onClick: handleTogglerCtaClick, "data-facil-iti": "header-menu-button" }), (0, jsx_runtime_1.jsxs)(Styled.StyledContent, { id: "left-menu-content", "$isOpen": isOpen, children: [(0, jsx_runtime_1.jsx)(Styled.MenuCloseWrapper, { onClick: handleTogglerCtaClick, children: (0, jsx_runtime_1.jsx)(Cross_1.default, {}) }), (0, jsx_runtime_1.jsxs)("div", { children: [(loginElement || lateralSignUpElement) && ((0, jsx_runtime_1.jsx)(Styled.List, { "data-facil-iti": "header-menu-login", children: (0, jsx_runtime_1.jsxs)(Styled.HeaderListItem, { "$isHeader": true, className: "left-menu-header", children: [!!loginElement && ((0, jsx_runtime_1.jsx)(loginBtn_1.default, { loginElement: loginElement, isTransparent: false, loginText: loginText, tracking: { position: constants_1.LoginButtonPosition.HEADER_MENU } })), !!lateralSignUpElement && (0, react_1.isValidElement)(lateralSignUpElement) && (0, react_1.cloneElement)(lateralSignUpElement)] }) })), !!lateralLoggedInHeader && (0, react_1.isValidElement)(lateralLoggedInHeader) && ((0, jsx_runtime_1.jsx)(Styled.List, { children: (0, jsx_runtime_1.jsx)(Styled.ListItem, { className: "left-menu-header", "$isHeader": true, children: (0, react_1.cloneElement)(lateralLoggedInHeader) }) })), (_a = menu === null || menu === void 0 ? void 0 : menu.sections) === null || _a === void 0 ? void 0 : _a.map((section) => (0, jsx_runtime_1.jsx)(section_1.default, { section: section, isOpenDoor: isOpenDoor })), !!lateralLoggedInFooter && (0, react_1.isValidElement)(lateralLoggedInFooter) && ((0, jsx_runtime_1.jsx)(Styled.LoggedInFooterWrapper, { children: (0, react_1.cloneElement)(lateralLoggedInFooter) }))] })] })] })] }));
};
exports.default = LateralMenu;
